// extracted by mini-css-extract-plugin
export default {"learnMoreButton":"_1vglBfugJ6HNdOrUWelQsi","tos-link":"ocoHrEDfNbubcJ61_8hwL"};